<template>
    <div class="dynamic-attr-text"
        :class="(attrObj.isCheckError?'is-check-error':'')">
        <div :class="'dynamic-attr-text-title '+ (attrObj.mustFlag=='1'?'is-item-required':'')"
            :style="{fontSize:$pScreen.titleS}">
            <span>{{ showNum(attrObj, currentPage) }} {{attrObj.title}}</span>
        </div>

        <div style="width:100%;margin-top:10px">
            <div @click.stop="channelClick"
                style="width: 100%; position: relative;text-overflow: ellipsis;">
                <Input v-model="attrObj.channelName"
                    class="storeSelect"
                    :placeholder="placeholderDesc"
                    :disabled="attrObj.disabled"
                    readonly />
                <img class="dateIcon"
                    src="../../../../../static/runtime/images/magic/downTriangleGray.svg"
                    alt="" />
                <!-- 清除按钮 -->
                <img v-if="attrObj.channelName && !attrObj.disabled"
                    class="clear-button"
                    @click.stop="clearInput"
                    src="../../../../../static/runtime/images/magic/clearStore.svg"
                    alt="" />
            </div>

            <div :class="['store', currentStore.channelAddress ? 'dynamic-class' : '']">
                <div :class="['store-left',currentStore.distance?'store-narrow':'store-wide']">
                    <div v-if="currentStore.channelAddress"
                        class="middle">{{currentStore.channelAddress}}</div>
                    <div v-if="getWorkingHours(currentStore)"
                        class="open-hours">营业时间 {{getWorkingHours(currentStore)}}</div>
                </div>
                <div v-if="currentStore.distance"
                    class="store-right">距您{{currentStore.distance}}km</div>
            </div>
            <div v-if="attrObj.isCheckError"
                class="errorTip">请选择门店</div>
        </div>
        <!-- :activityCode="attrObj.activityCode"  :activityCode="'HD1748499035908'" -->
        <store-modal ref="storeModal"
            :activityCode="attrObj.channelActivityCode"
            :currentStore="currentStore"
            :customFormFlag="true"
            @changeStore="changeStoreHandler"></store-modal>
    </div>
</template>




<script>
import { Cell, DatetimePicker, ActionSheet, Field, Row, Col, Toast } from 'vant';
import { FormType } from '../../../../commons/commonVariables.js';
import storeModal from '../../runtime/lucky-draw/components/store-modal.vue';
import { AMapGetLocation } from '../TMap.js';
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Cell.name]: Cell,
    [DatetimePicker.name]: DatetimePicker,
    [ActionSheet.name]: ActionSheet,
    [Field.name]: Field,
    storeModal,
  },
  props: {
    attrObj: Object,
    currentPage: {
      type: Number,
      default: 0,
    },
    channelStore: Object,
    positionInfo: {
      type: Object,
      default() {
         return{
          longitude: "116.4074",
          latitude: "39.9042"
          }
      },
    },
  },

  data() {
    return {
      minDate: new Date(),
      currentDate: new Date(),

      placeholderDesc: !this.attrObj.desc ? '请选择' : this.attrObj.desc,
      
      currentStore: {},
    };
  },

  watch: {
    attrObj: {
      handler(newValue) {
        if (this.channelStore) {
          this.currentStore = this.channelStore;
        } else {
          this.currentStore = {};
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 只有趣味表单才展示题号
    showNum(item, current) {
      if (item.formType !== FormType.interestForm) {
        return '';
      } else {
        return `${current + 1}.`;
      }
    },
    async channelClick() {
      if (this.attrObj.disabled) {
        return; // 如果是禁用状态，直接返回，不执行后续逻辑
      }

      this.$refs.storeModal && this.$refs.storeModal.openModal(this.positionInfo);
    },
    // 切换门店
    changeStoreHandler(item) {
      console.log('changeStoreHandler===>item: ', item);
      this.$nextTick(()=>{
        this.currentStore = Object.assign({}, item);
      })
      this.attrObj.answerContent = item.channelCode + ':' + item.channelName+'-' + this.attrObj.channelActivityCode;
      this.attrObj.channelName = item.channelName;
      this.attrObj.activityChannelId = item.id;
    },
    getWorkingHours(item) {
      const startTime = item.workStartTime && item.workStartTime.slice(10, 19);
      const endTime = item.workEndTime && item.workEndTime.slice(10, 19);
      const workingTime = startTime + ' ~' + endTime;
      return startTime && endTime ? workingTime : '';
    },

    clearInput() {
      this.attrObj.answerContent = '';
      this.attrObj.channelName = '';
      this.attrObj.activityChannelId = '';
      Object.keys(this.currentStore).forEach((key) => {
        this.$delete(this.currentStore, key);
      });
    },
  },
};
</script>
<style lang="scss">
.dynamic-attr-text {
  font-size: 12px;
}
.customField {
  line-height: 1.5;
  padding: 4px 8px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  background: #fff;
  font-size: 14px;
  color: #515a6e;
}
.customField01 {
  line-height: 1.5;
  padding: 4px 8px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  background: #f3f3f3;
  font-size: 14px;
  color: #ccc;
}
.storeSelect{
  text-overflow: ellipsis;

}
.storeSelect .ivu-input {
  color: #515a6e;
  font-size: 14px;
  padding-right: 20% !important;
  text-overflow: ellipsis;
}
.ivu-input[disabled] {
  background: #f3f3f3;
  opacity: 1;
  cursor: not-allowed;
  color: #ccc;
  font-size: 14px;
}
.dateIcon {
  position: absolute;
  right: 8px;
  top: 7px;
  width: 20px;
  height: 20px;
}

.dynamic-class {
  padding: 10px;
}
.clear-button {
  position: absolute;
  width: 20px;
  height: 20px;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-weight: 600;
  cursor: pointer;
  z-index: 777;
}
.store {
  background-color: #fff;
  padding-right: 0;
  display: flex;
  font-size: 12px;
  margin-top: 10px;
  border-radius: 5px;
  position: relative;
  .store-left {
    padding-right: 10px;
    .top {
      height: 20px;
      font-size: 16px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .middle {
      margin-top: 5px;
      color: #999;
    }
    .open-hours {
      color: #999;
      font-size: 12px;
    }
    .bottom {
      height: 12px;
      margin-top: 5px;
    }
  }
  .store-narrow {
    border-right: #00000030 solid 1px;
    width: calc(100% - 90px);
  }
  .store-wide {
    width: 100%;
  }
  .store-right {
    width: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/channel.vue